import { blackDark } from '../../shadows';

export const classes = {
  root: {
    backgroundColor: blackDark,
  },
};
